import React, { useEffect, useState } from 'react';
import VoucherAssignmentConfig from './VoucherAssignmentConfig';
import { getDropdowns } from './utils';
import {ReactComponent as BackArrow} from "assets/img/svg/BackArrow.svg";
import { useHistory } from 'react-router-dom';

const VoucherSetup = () => {
    const [dropdownData, setDropdownData] = useState({});

    const history = useHistory();

    const init = async() => {
        try{
            const dropdowns = await getDropdowns();
            setDropdownData(dropdowns);
        }catch(err){
           console.error(err);
        }
    }

    useEffect(() => {
        init();
    },[])

    return ( 
        <div className='d-flex flex-column'>
        
        <div className='d-flex align-items-center m-2 color-dark'>

        <BackArrow className='mr-2 cursor' onClick={() => history.goBack()}/>
        <h2 className='mb-0 color-dark'>Voucher Setup</h2>

        </div>

        <VoucherAssignmentConfig dropdownData={dropdownData} isPANIndiaConfig={true}/>

        <VoucherAssignmentConfig dropdownData={dropdownData}/>
        </div>
     );
}
 
export default VoucherSetup;